import {
	SET_AI_BASE,
	MULTIBASE_AI_LIST,
	CLEAR_STORE,
	SET_AI_BASE_REQUEST,
	SET_AI_BASE_REQUEST_SUCCESS,
	SET_AI_BASE_REQUEST_FAILED,
	SET_AI_BASE_REQUEST_FAILED_CLEAR,
	CLEAR_MULTIBASE,
} from "../types"

export const setAIBase = (selectedBase) => ({
	type: SET_AI_BASE,
	payload: selectedBase,
})

export const setMultiBaseList = (multiBaseList) => ({
	type: MULTIBASE_AI_LIST,
	payload: multiBaseList,
})

export const cleanStore = () => ({
	type: CLEAR_STORE,
})

export const setAIBaseRequest = (data) => ({
	type: SET_AI_BASE_REQUEST,
	payload: data,
})

export const setAIBaseRequestSuccess = (data) => ({
	type: SET_AI_BASE_REQUEST_SUCCESS,
	payload: data,
})

export const setAIBaseRequestFailed = (data) => ({
	type: SET_AI_BASE_REQUEST_FAILED,
	payload: data,
})

export const setAIBaseRequestFailedClear = () => ({
	type: SET_AI_BASE_REQUEST_FAILED_CLEAR,
})

export const clearMultibase = () => ({
	type: CLEAR_MULTIBASE,
})
